import type { TConstructionTypesIndexes } from '../types';

export const defaultCounts: Record<TConstructionTypesIndexes, number> = {
    '-2': 0,
    '-3': 0,
    '-4': 0,
    '-5': 0,
    '-6': 0,
    '-7': 0,
    '-8': 0,
    '-9': 0,
};
